export const ONE_HOUR = "60";
export const headerWidth = "300px";
export const DEFAULT_HEAD_COUNT = 0;
export const SLASH = "/";
export const COLON = ":";
export const ACTUALS = "Actuals";
export const INDUCT_ACTUALS = 0;
export const INDUCT_PLANNED = 1;
export const STOW_ACTUALS = 2;
export const STOW_PLANNED = 3;
export const INDUCT_MHE_ACTUALS = 4;
export const INBOUND_ACTUALS = 0;
export const INBOUND_PLANNED = 1;
export const INDUCT = "Induct";
export const AUTO_SCAN_INDUCT_LOADER = "Auto Scan Induct Loader";
export const STOW = "Stow";
export const LINEHAUL_STATUS = {
  ARRIVED: "ARRIVED",
  IN_TRANSIT: "IN_TRANSIT",
  PENDING_DEPART: "PENDING_DEPART",
};
export const NOT_AVAILABLE = "N/A";
export const RESOLUTION = {
  HOURLY: "HOURLY",
  QUARTER_HOURLY: "QUARTER_HOURLY",
};

export const filters = {
  Sort: new Set([
    "Inbound Dock W/S",
    "Induct Line Loader",
    "Induct",
    "Pusher",
    "Diverter",
    "Pick to Buffer",
    "Non-Scan Stow",
    "Sort Problem Solve",
    "Container Building",
    "Stow",
    "Auto Divert Straightener",
    "Auto Scan Pusher",
    "Auto Scan Induct Loader",
    "ADTA Container Building",
    "Non-Con Manual Handling",
    "Non Con Manual Handling",
  ]),
  "Pick Stage": new Set([
    "Non-Scan Pick & Stage",
    "UTR Dispatch",
    "Yard Assist and Cart Handling",
    "Pick & Stage - Pick",
    "Pick Stage Problem Solve",
    "Pick Stage & Dispatch Problem Solve",
  ]),
  UTR: new Set([
    "UTR OPS Supervisor / SA",
    "Stow Bag Replenishment",
    "Yard Marshall",
    "Learning Coordinator",
    "5S",
  ]),
  "Site Support": new Set([
    "HR",
    "Sustainability",
    "Safety",
    "Training / Safety School",
    "Training Ambassador",
  ]),
  "Off Task": new Set(["Off Task"]),
  OTR: new Set(["OTR Supervisor", "OTR Support"]),
  SWA: new Set(["SWA Indirects"]),
  RTS: new Set(["Reverse Stow", "RTS"]),
  "Non-Core Support": new Set(["Non-Core Support", "CS DSL"]),
};
export const OTR = {
  "OTR Supervisor": {
    name: "OTR Supervisor",
    alias: "OTR Supervisor",
    id: "package_overview.otr_supervisor",
  },
  "OTR Support": {
    name: "OTR Support",
    alias: "OTR Support",
    id: "package_overview.otr_support",
  },
};
export const SWA = {
  "SWA Indirects": {
    name: "SWA Indirects",
    alias: "SWA Indirects",
    id: "package_overview.swa_indirects",
  },
};
export const RTS = {
  "Reverse Stow": {
    name: "Reverse Stow",
    alias: "Reverse Stow",
    id: "package_overview.reverse_stow",
  },
  RTS: {
    name: "RTS",
    alias: "RTS",
    id: "package_overview.rts",
  },
};
export const NonCoreSupport = {
  "Non-Core Support": {
    name: "Non-Core Support",
    alias: "Non-Core Support",
    id: "package_overview.ncs_support",
  },
  "CS DSL": {
    name: "CS DSL",
    alias: "CS DSL",
    id: "package_overview.ncs_cs_dsl",
  },
};
export const SORT = {
  "Auto Scan Induct Loader": {
    name: "Auto Scan Induct Loader",
    alias: "Auto Scan Induct Loader",
    id: "package_overview.auto_scan_induct_loader",
  },
  "Auto Scan Pusher": {
    name: "Auto Scan Pusher",
    alias: "Auto Scan Pusher",
    id: "package_overview.auto_scan_pusher",
  },
  "Auto Divert Straightener": {
    name: "Auto Divert Straightener",
    alias: "Auto Divert Straightener",
    id: "package_overview.auto_divert_straightener",
  },
  "ADTA Container Building": {
    name: "ADTA Container Building",
    alias: "ADTA Container Building",
    id: "package_overview.adta_container_building",
  },
  Diverter: {
    name: "Diverter",
    alias: "Diverter",
    id: "package_overview.sort_diverter",
  },
  "Induct Dock W/S": {
    name: "Induct Dock W/S",
    alias: "Inbound Dock W/S",
    id: "package_overview.sort_induct_dock",
  },
  Induct: {
    name: "Induct",
    alias: "Induct",
    id: "package_overview.sort_induct",
  },
  "Induct Line Loader": {
    name: "Induct Line Loader",
    alias: "Induct Line Loader",
    id: "package_overview.sort_induct_line",
  },
  "Non-Scan Stow": {
    name: "Non-scan Stow",
    alias: "Non-Scan Stow",
    id: "package_overview.sort_non_scan_stow",
  },
  "Pick to Buffer": {
    name: "Pick to Buffer",
    alias: "Pick to Buffer",
    id: "package_overview.sort_pick_to_buffer",
  },
  Pusher: {
    name: "Pusher",
    alias: "Pusher",
    id: "package_overview.sort_pusher",
  },
  "Sort Problem Solver": {
    name: "Sort Problem Solver",
    alias: "Sort Problem Solve",
    id: "package_overview.sort_problem_solver",
  },
  Stow: {
    name: "Stow",
    alias: "Container Building",
    id: "package_overview.sort_stow",
  },
  "Non-Con Manual Handling": {
    name: "Non-Con Manual Handling",
    alias: "Non Con Manual Handling",
    id: "package_overview.sort_non_con_manual_handling",
  },
};

export const PICK_STAGE = {
  "Non-Scan Pick & Stage": {
    name: "Non-Scan Pick & Stage",
    alias: "Non-Scan Pick & Stage",
    id: "package_overview.non_scan_pick_stage",
  },
  "Pick & Stage - Pick": {
    name: "Pick & Stage - Pick",
    alias: "Pick & Stage - Pick",
    id: "package_overview.stage_pick",
  },
  "Pick Stage Problem Solve": {
    name: "Pick Stage Problem Solve",
    alias: "Pick Stage Problem Solve",
    id: "package_overview.stage_problem_solve",
  },
  "Pick Stage & Dispatch Problem Solve": {
    name: "Pick Stage & Dispatch Problem Solve",
    alias: "Pick Stage & Dispatch Problem Solve",
    id: "package_overview.pick_stage_dispatch_problem_solve",
  },
  "UTR Dispatch": {
    name: "UTR Dispatch",
    alias: "UTR Dispatch",
    id: "package_overview.utr_dispatch",
  },
  "Yard Assist and Cart Handling": {
    name: "Yard Assist and Cart Handling",
    alias: "Yard Assist and Cart Handling",
    id: "package_overview.yard_assist_and_cart_handling",
  },
};

export const UTR = {
  "Learning Coordinator": {
    name: "Learning Coordinator",
    alias: "Learning Coordinator",
    id: "package_overview.utr_coordinator",
  },
  "Stow Bag Replenishment": {
    name: "Stow Bag Replenishment",
    alias: "Stow Bag Replenishment",
    id: "package_overview.utr_stow",
  },
  "UTR OPS Supervisor / SA": {
    name: "UTR OPS Supervisor / SA",
    alias: "UTR OPS Supervisor / SA",
    id: "package_overview.utr_ops",
  },
  "Yard Marshall": {
    name: "Yard Marshall",
    alias: "Yard Marshall",
    id: "package_overview.utr_yard",
  },
  "Empty Cart Returns": {
    name: "Empty Cart Returns",
    alias: "Empty Cart Returns",
    id: "package_overview.utr_empty_cart_returns",
  },
  "5S": {
    name: "5S",
    alias: "5S",
    id: "package_overview.utr_5S",
  },
};

export const SITE_SUPPORT = {
  HR: {
    name: "HR",
    alias: "HR",
    id: "package_overview.ss_hr",
  },
  Sustainability: {
    name: "Sustainability",
    alias: "Sustainability",
    id: "package_overview.ss_sustainability",
  },
  Safety: {
    name: "Safety",
    alias: "Safety",
    id: "package_overview.ss_safety",
  },
  "Training / Safety School": {
    name: "Training / Safety School",
    alias: "Training / Safety School",
    id: "package_overview.ss_training",
  },
};

export const PLANNED_HC_PROCESS_ALIAS = {
  "Container Building": "Stow",
  "Training / Safety School": "Training Ambassador",
  "Non Con Manual Handling": "Non-Con Manual Handling",
};



// WEBPACK FOOTER //
// ./src/components/overview/utils/PPAConstants.js